module.exports = __webpack_public_path__ + "static/media/doc12.2c472063.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc12.png
// module id = 64
// module chunks = 0